import produce from 'immer';
import * as actions from '../actions/actionTypes';
import { maximumUnreadMessageBadgeCount } from '../utils/ChatModule';

const chat = (state = initChatStore(), action) => 
    produce(state, draft => {
        switch (action.type) {
            case actions.CHAT_UPDATE_UNREAD_MESSAGES:
                draft.unreadMessages = action.unreadMessages;
                break;
            case actions.CHAT_MAXIMUM_UNREAD_MESSAGE_COUNT: 
                draft.maximumUnreadMessageCount = action.maximumUnreadMessageCount;
                break;
            // react to original login saga and react to the change
            case actions.LOGIN_PATIENT_SUCCESS:
                draft.hasCCToken = !!action?.payload?.session?.token;
                break;
            case actions.CHATHUB_JOIN_SUCCESS:
                draft.hasMatrixToken = !!action?.data?.chat?.credential;
                break;
            case actions.CHATHUB_JOIN_FAILURE:
                draft.hasJoinError = !!action?.hasJoinError;
                break;
            default: 
                break;
        }
    });

export const initChatStore = () => {
    return {
        unreadMessages: 0,
        maximumUnreadMessageCount: maximumUnreadMessageBadgeCount,
        hasCCToken: false,
        hasMatrixToken: false,
        hasJoinError: false,
    };
};

export default chat;
